// 繁中
export default {
  // 水果转盘
  fruitTurntable: {
    recordsTitle: "記錄",
    emptyRecords: "暫無水果轉盤記錄",
    guessResult: "競猜結果",
    myGuesses: "我的競猜",
    guessFailed: "競猜失敗",
    winningPlayers: "獲勝玩家",
    noGuesses: "本局未參與競猜",
    noWinners: "本局暫無獲勝玩家",
    rulesTitle: "玩法說明",
    rulesDescription: "每局50s的競猜時間，玩家可以競猜本局開出的水果。競猜正確將獲得對應的露水獎勵。",
    guessingTitle: "競猜方法",
    guessingDescription: "在競猜時間內，選擇您要競猜的露水數量，點擊畫面中的水果下注區域進行競猜。",
    rewardsTitle: "獎勵說明",
    rewardsDescription: "競猜不同的水果將獲得不同的露水獎勵",
    fruit: "水果",
    multiplier: "獎勵倍數",
    apple: "蘋果",
    watermelon: "西瓜",
    orange: "橙子",
    banana: "香蕉",
    grape: "葡萄",
  },
  // 任命社长
  setPresident: {
    intro: "您可以設置社長來幫助管理您的社團",
    selfIntro: "您是社團的社長",
    president: "社長",
    empty: "未設置社長",
    appoint: "去任命",
    privileges: "社長職能",
    privilegesIntro: "社長擁有以下職能",
    title: "設置社長",
    selectMember: "選擇您要任命為社長的社員",
    member: "社員",
    attendance: "到場{days}天",
    weekContribution: "聲望貢獻 (週):",
    monthContribution: "(月):",
    confirmAppoint: "是否任命該社員為社長？",
    confirm: "確認",
    remove: "解除任命",
    cancel: "取消",
    removeTitle: "解除社長任命",
    confirmRemove: "是否確認解除社長 {name} 的任命？",
    unnamed: "未命名",
    pkTitle: "PK 房間",
    pkDesc: "社長可以開啟、關閉、管理本社團的 PK 房間",
    infoTitle: "社團資訊",
    infoDesc: "社長和領主有權限編輯社團封面、名稱、宣言等社團資訊",
    membersTitle: "社員管理",
    membersDesc: "社長和領主都有權限清除社團的社員、門客",
    rewardsTitle: "社團獎勵",
    rewardsDesc: "社長可以領取社團相關的獎勵，如果未設置社長，則無法領取",
    moderationTitle: "直播間場控",
    moderationDesc: "社長自動獲得領主直播間的場控權限",
    newPlayersTitle: "新玩家頻道",
    newPlayersDesc: "社長和領主可以查看新玩家頻道",
    loadMembersFailed: "獲取社員列表失敗",
    appointFailed: "設置社長失敗",
    appointSuccess: "設置成功",
    removeFailed: "解除任命失敗",
    removeSuccess: "解除成功",
    customerService: "客服",
    loadClubFailed: "獲取社團資訊失敗",
  },
  
  /* 總榜單 */
  allRank: {
    lang1: "主播",
    lang2: "富豪",
    lang3: "PK",
    lang4: "團戰",
    lang5: "華語",
    lang6: "英語",
    lang7: "泰語",
    lang8: "日語",
    lang9: "印尼語",
    lang10: "越南語",
    lang11: "小時",
    lang12: "日榜",
    lang13: "週榜",
    lang14: "本週",
    lang15: "上週",
    lang16: "月榜",
    lang17: "縂榜",
    lang18: "獎勵",
    lang19: "接通率",
    lang20: "團積分",
    lang21: "團員",
    lang22: "暫無數據",
    lang23: "暫未登榜",
    lang24: "珍愛團",
    lang25: "約會",
    lang26: "自己不能關注自己哦",
    lang27: "關注成功",
    lang28: "已取消關注",
    lang29: "虛位以待",
    lang30: "昨日",
    lang31: "上月",
    lang32: "未上榜",
    lang33: "我的排名",
    lang34: "使者",
    lang35: "獎勵月榜",
    lang36: "人數月榜",
    lang37: "社團",
    lang38: "珍愛團",
    lang39: "暫無宣言",
    lang40: "社員",
    lang41: "成員",
    lang42: "週聲望",
    lang43: "總聲望",
    lang44: "社團榜單",
    lang45: "分享",
    lang46: "啟動",
    lang47: "發來的社團邀請",
    lang48: "啟動FIREFLY,發現更多有趣主播",
    lang49: "獎勵週榜",
    lang50: "人數週榜",
    lang51: "聲望",
    lang52: "獎",
  },

  /* 俱乐部 */
  club: {
    lang1: "主播",
    lang2: "富豪",
    lang3: "PK",
    lang4: "團戰",
    lang5: "華語",
    lang6: "英語",
    lang7: "泰語",
    lang8: "日語",
    lang9: "印尼語",
    lang10: "越南語",
    lang11: "小時",
    lang12: "日榜",
    lang13: "週榜",
    lang14: "本週",
    lang15: "上週",
    lang16: "月榜",
    lang17: "縂榜",
    lang18: "獎勵",
    lang19: "接通率",
    lang20: "團積分",
    lang21: "團員",
    lang22: "暫無數據",
    lang23: "暫未<br>登榜",
    lang24: "珍愛團",
    lang25: "約會",
    lang26: "自己不能關注自己哦",
    lang27: "關注成功",
    lang28: "已取消關注",
    lang29: "虛位以待",
    lang30: "積分貢獻榜",
    lang31: "排名",
    lang37: "社團",
    lang38: "珍愛團",
    lang39: "暫無宣言",
    lang40: "成員",
    lang41: "成員",
    lang42: "週聲望",
    lang43: "總聲望",
    lang44: "社團榜單",
    lang45: "分享",
    lang46: "啟動",
    lang47: "發來的社團邀請",
    lang48: "啟動FIREFLY，加入社團一起玩吧~",
    lang49: "社團",
    lang50: "領主：",
    lang51: "社長：",
    // 社團榜「我的排名」列的角色的徽章文案。
    lang52: "領主",
    lang53: "社長",
    lang54: "社員",

    lang55: "無社員歸屬",

    lang56: "未設置社員歸屬的社團",
  },

  /* 榜单 */
  rank: {
    lang1: "主播",
    lang2: "富豪",
    lang3: "PK",
    lang4: "團戰",
    lang5: "華語",
    lang6: "英語",
    lang7: "泰語",
    lang8: "日語",
    lang9: "印尼語",
    lang10: "越南語",
    lang11: "小時",
    lang12: "日榜",
    lang13: "週榜",
    lang14: "本週",
    lang15: "上週",
    lang16: "月榜",
    lang17: "縂榜",
    lang18: "獎勵",
    lang19: "接通率",
    lang20: "團積分",
    lang21: "團員",
    lang22: "暫無數據",
    lang23: "暫未登榜",
    lang24: "珍愛團",
    lang25: "約會",
    lang26: "自己不能關注自己哦",
    lang27: "關注成功",
    lang28: "已取消關注",
    lang29: "虛位以待",
    lang30: "昨日",
    lang31: "上月",
    lang32: "未上榜",
    lang33: "我的排名",
    newDraw96: "私房",
  },

  /* TOP集合 */
  topRankList: {
    title: "螢光榜單TOP集合",
    playerCoreTitle: "玩家核心TOP",
    playerCoreSubTitle: "Top Rich",
    anchorCoreTitle: "主播核心TOP",
    anchorCoreSubTitle: "Top FIREs",
    playerCenterTitle: "玩家榜集群",
    playerCenterSubTitle: "Ranking Center",
    anchorCenterTitle: "主播榜集群",
    anchorCenterSubTitle: "FIREs Ranking Center",
    richBoard: "FIREFLY 富豪榜",
    anchorBoard: "FIREFLY 主播榜",
    clubBoard: "社團榜",
    emissaryBoard: "使者榜",
    mountBoard: "座駕名人榜",
    ludoBoard: "LUDO PK 榜",
    gardenBoard: "螢火花園榜",
    firstLoveBoard: "首禮榜",
    newStarBoard: "新星榜",
    pkBoard: "PK 榜",
    privateCreditBoard: "私房信用榜",
  },

  /* 珍愛團 */
  treasureGroup: {
    lang1: "主播",
    lang2: "富豪",
    lang3: "PK",
    lang4: "團戰",
    lang5: "華語",
    lang6: "英語",
    lang7: "泰語",
    lang8: "日語",
    lang9: "印尼語",
    lang10: "越南語",
    lang11: "小時",
    lang12: "日榜",
    lang13: "週榜",
    lang14: "本週",
    lang15: "上週",
    lang16: "月榜",
    lang17: "縂榜",
    lang18: "獎勵",
    lang19: "接通率",
    lang20: "團積分",
    lang21: "團員",
    lang22: "暫無數據",
    lang23: "暫未<br>登榜",
    lang24: "珍愛團",
    lang25: "約會",
    lang26: "自己不能關注自己哦",
    lang27: "關注成功",
    lang28: "已取消關注",
    lang29: "虛位以待",
    lang30: "積分貢獻榜",
    lang31: "排名",
    lang37: "社團",
    lang38: "珍愛團",
    lang39: "暫無宣言",
    lang40: "成員",
    lang41: "成員",
    lang42: "週聲望",
    lang43: "總聲望",
    lang44: "社團榜單",
    lang45: "分享",
    lang46: "啟動",
    lang47: "發來的社團邀請",
    lang48: "啟動FIREFLY，加入社團一起玩吧~",
  },

  /* 聲望值記錄 */
  treasureRecord: {
    recordTitle2: "聲望值記錄",
    income10: "本月",
    income11: "上月",
    news7: "事項 ",
    news13: "聲望值",
    cashreal6: "取消",
    box1: "暫無記錄",
  },

  /* 社團分享 */
  groupShare: {},

  /* 俱乐部说明页 */
  groupIntruduction: {
    lang1: "社團の簡介",
    lang2:
      "社團是由主播的核心粉絲構成的群體組織。<br/>加速社團可以共同參與趣味活動及競技，和同樣社團裡的同好成為朋友。<br/>粉絲群體的數量和聲網是社團主要競爭點，也象征創建主播的影響力和人氣。",
    lang3: "社團の專門屬性介紹",
    lang4: "C.by 創建者：",
    lang5:
      "社團的開創者，通常是主播。由主播根據自己的追蹤人群達到一定數量後，開通社團。",
    lang6: "P.by 會長：",
    lang7:
      "社團的管理者，由主播指定後生效。社團的會長同時成為C.by創建者的直播間場控。",
    lang8: "成員：",
    lang9:
      "社團的成員。加入方式為直播中送出 珍愛你 或 社團粉絲瓶 禮物。任何社團成員數量無限制。",
    lang10: "專屬禮物：",
    lang11: "社團競爭用專門禮物。送出專屬禮物可獲得聲望值積累。",
    lang12: "聲望值：",
    lang13:
      "1.在社團的創建人的直播間送出社團專屬禮物，可累積聲望值。<br/>2.在社團的創建人的直播間內完成每日社團任務，可累積聲望值。",
    lang14: "聲望：",
    lang15:
      "同個社團內所有成員的聲望值之和，為本社團的聲望。社團內所有成員每週增加的聲望值之和，為本社團的週聲望",
    lang16: "成員の等級",
    lang17:
      "1.累積聲望值的過程即為完成升級的過程，具體參考上方圖標<br/>2.贈送聲望禮物10寶石 = 1聲望值（不影響禮物其他屬性）。<br/>3.當日聲望值累積至上限後不在提升。",
    lang18: "成員の降級",
    lang19:
      "1.在社團內，當成員連續3日未貢獻任何聲望值後，第4日起開始聲望值的衰減。<br/>2.聲望值的持續衰減會導致成員降級，具體參考成員の等級。<br/>3.聲望值降低至0則本成員自動退出該社團。",
    lang20: "成員の特權",
    lang21: "其他",
    lang22:
      "若社團出現刷號、作弊、名字或封面違反所在地法律法規等情形，FIREFLY平台方有權修改或者刪除改社團",
    lang23: "社團等級",
    lang24: "升級所需聲望值",
    lang25: "每日禮包",
    lang26: "聲望值上限",
    lang27: "衰減",
    lang28: "特權",
    lang29: "描述",
    lang30: "社團銘牌",
    lang31: "在C.by創建者的主播直播間的特殊等級標識",
    lang32: "專屬禮物",
    lang33: "在C.by創建者的主播直播間的專屬禮物",
    lang34: "專屬聊天框",
    lang35: "在C.by創建者的主播直播間的專屬聊天框",
    lang36: "社團寶箱",
    lang37: "在C.by創建者的主播直播間可以搶奪社團寶箱的特權",
    lang38: "每日禮包",
    lang39: "在C.by創建者的主播直播間內可以完成每日任務領取的禮包",
    lang40: "成員暢聊",
    lang41: "在私信中與社團內所有成員聊天無親密度限制",
    lang42: "刷新",
    lang43: "客服咨詢",
    lang44: "關閉頁面",
    lang45: "社團",
    lang46: "Club",
    lang47:
      "社團是玩家與領主共同建立的專屬陣營。玩家可以透過加入社團、為社團貢獻聲望，社團之間爭奪榮譽，贏得專屬榜單獎勵！",
    lang48: "社員歸屬",
    lang49:
      "每個玩家可以最多設置一個自己的社員歸屬社團。設置社員歸屬後，您在該社團中的角色將更改為「社員」。設置社員歸屬後，獲得榮譽聲望（榜單冠軍、夜間選秀冠軍等）、PK房間遊戲獲勝都將自動貢獻到社員歸屬的社團。",
    lang50: "社團加入/退出",
    lang51:
      "玩家通過贈送領主「瑩心錘」禮物，加入領主所在的社團。送禮加入社團之後的角色為「門客」。玩家可以自己自由選擇退出社團。",
    lang52: "聲望",
    lang53:
      "聲望是社團比拼競爭的核心。聲望由社團內的所有成員通過完成社團任務、競爭榜單活動冠軍、遊戲參與與獲勝來貢獻給所在的社團。",
    lang54: "社團獎勵",
    lang55:
      "社團通過競爭獲得獎勵時，將發放給社團的社長。如果社團未設置社長，則無法接收社團獎勵。",
    lang56: "社團上榜",
    ranked: "已上榜",
    lang57: "社團滿足了以下條件可以參與FIREFLY Club 社團榜的排行",
    lang58: "更改了社團名稱",
    lang59: "更改了社團封面",
    lang60: "設置了社長",
    lang61:
      "未滿足以上條件的社團不影響正常玩家的加入和聲望的累計，僅無法參與榜單排行。",
    lang62: "社團角色",
    lang63: "Club Role",
    lang64: "領主 Load",
    lang65:
      "領主是社團的創建人，與社團深度綁定。領主擁有社團的管理與編輯權力，並可以為社團設置社長。",
    lang66: "社長 Boss",
    lang67:
      "由領主任命指定，擁有社團的管理與編輯權限。可以開啟所在社團的PK房間。",
    lang68:
      "<span class='highlight-text'>社團獎勵：</span>為社團發放的獎勵，都將發放給社長。如果社團未設置社長，則無法接收社團獎勵。",
    lang69: "社員 Members",
    lang70:
      "已加入該社團，且將該社團設定為「歸屬社團」的玩家。社員獲得的榮譽聲望、遊戲聲望獎勵將自動貢獻到歸屬的社團。",
    lang71: "門客 Guest",
    lang72: "已加入該社團，但未將其設定為「歸屬社團」的玩家。",
    lang73: "王者社團",
    lang74:
      "每週FIREFLY的社團周榜冠軍社團，即成為下一周的「王者社團」。王者社團生效期間，門客無法將王者社團設置為社員歸屬。王者社團的社員在所有直播間都會顯示社團名稱。",
    lang75: "更多",
  },

  /* 萤火花园 */
  fireflyGarden: {
    lang1: "花園",
    lang2: "任務",
    lang3: "榜單",
    lang4: "花園の記錄",
    lang5: "種花",
    lang6: "澆水",
    lang7: "澆灌了",
    lang8: "暫無數據",
    lang9: "花園の規則",
    lang10:
      "玩家點擊花盆選擇要種植的花，種植之後等待開花時間到了之後，將隨機開出不同價值的禮物。玩家的富豪值根據花的價格增加。未到開花時間直播間關閉，則寶石將原路退回。",
    lang11:
      "玩家可以使用道具「花園の水壺卡」澆灌他人種下的花，每次澆灌可以減少開花時間 1 分鐘",
    lang12: "花の等級",
    lang13:
      "根據花開出的禮物價值累計升級。更高的花の等級可以解鎖更多可以種植的花",
    lang14: "盆の等級",
    lang15:
      "根據種植在該花盆的花開出的禮物價值累計。更高的盆の等級可以減少開花時間<br> 一星花盆：開花時間 減少1分鐘<br> 二星花盆：開花時間 減少2分鐘<br> 三星花盆：開花時間 減少4分鐘",
    lang16: "全收集",
    lang17:
      "每朵花可以開出不同的禮物，玩家開出了一朵花中所有的禮物之後，則達成「全收集」。普通花朵達成「全收集」可以解鎖星級花朵，星級花朵達成「全收集」可獲得對應獎勵。",
    /* 週/月選項與文案 */
    lang18: "本週",
    lang19: "上週",
    lang20: "本月",
    lang21: "上月",

    /* 狀態與提示 */
    lang22: "週榜冠軍獲得禮物 花海漫遊 x1",
    lang23: "全收集解鎖",
    lang24: "解鎖",
    lang25: "請選擇你要種的花",
    lang26: "取消",
    lang27: "贈送",
    lang28: "確定",
    lang29: "開花時間：",
    lang30: "分鐘",
    lang31: "開花隨機送出以下禮物",
    lang32: "已收集",
    lang33: "全收集",
    lang34: "開花後送出禮物完成收集，完成全收集可領取",
    lang35: "開花後送出禮物完成收集，完成全收集可解鎖隱藏花",
    lang36: "已解鎖",
    lang37: "未解鎖",
    lang38: "已領取",
    lang39: "領取",
    lang40: "隱世曇花已解鎖",
    lang41: "達成全收集後可領取",
    lang42: "每日完成花園の任務可領取道具獎勵",
    lang43: "去完成",
    lang44: "週榜冠軍獲得禮物 花海漫遊 x1",
    lang45: "螢火の花園新一期已開啟，請重新操作",
    lang46: "花園の水壺卡",
    lang47: "每月月榜前30名玩家，可獲得獎勵「花園の跳級卡」",
    lang48: "花の等級達到Lv.$後可查看",
    lang49: "完成全收集，解鎖",
    lang50: "天",
    lang51: "請前往「任務中心」-「獎勵領取」領取獎勵",
    lang52: "去領取",
    lang53: "「花園の水壺卡」數量不足",
    lang54: "未收集",
    lang55: "完成全收集，可領取獎勵",
    lang56: "禮物概率",
    lang57: "禮物详情",
    lang58: "禮物名稱",
    lang59: "開出概率",
    lang60: "限時",
    /* 任務文案 */
    task1Title: "每日簽到",
    task1Desc: "每日登入簽到可領取",
    task2Title: "每日儲值",
    task2Desc: "每日完成儲值可領取",
    task3Title: "每日種花",
    task3Desc: "每日完成種花後可領取",
  },

  /* 極速狂飈 */
  kingOfSpeed: {
    lang1: "玩法規則",
    lang2: "游戲説明",
    lang3:
      "1.投擲骰子：玩家每次點擊投擲骰子消耗1000露水，投擲骰子給隊伍的賽車獲取加成效果。",
    lang4: "2.骰子機率：6個效果抽取的機率相同，6個面加成效果不同。",
    lang5:
      "3.遊戲結果：遊戲PK時間結束時行駛距離高的隊伍獲勝，行駛距離低的隊伍失敗，如果雙方行駛距離相同，則為平局。",
    lang6: "座駕說明",
    lang7: "1.座駕要求：遊戲開始時主播若無座駕，當前隊伍的賽車無法形成。",
    lang8: "氣の等級說明",
    lang9:
      "1.提升等級：雙方玩家通過互動為主播增加人氣值，人氣值用於提升隊伍氣の等級，氣の等級越高骰子的加成效果越強",
    lang10: "2.气の等级要求：",
    lang11: "骰子等級",
    lang12: "人氣值",
    lang13: "露水獎池說明",
    lang14:
      " 1.露水獎池：雙方玩家投擲骰子的露水將累計到露水獎池中，遊戲結束後獲勝隊伍將獲得露水獎池中所有的露水作為獎勵。遊戲平局時，雙方隊伍的玩家均可獲得露水獎池的獎勵。",
    lang15:
      "2.獎勵分配：根據獲勝隊伍中每名玩家擲骰子的露水佔比分配。沒有擲骰子參與遊戲的玩家不參與露水獎池的獎勵分配。",
    lang16: "3.服務費用：玩家從露水獎池中獲得獎勵，平台將收取4%的服務費用。",
    lang17: "游戲開發說明",
    lang18:
      "1.玩家可在2025年10月23日 12:00-2025年12月17日 00:00，期間内通過游戲PK參與極速狂飆。",
    lang19: "注意事項",
    lang20: "1.活動內設計的所有時間皆以伺服器時間為準。",
    lang21:
      "2.為確保遊戲公平性，遊戲中由於不可抗力因素，如網絡、作弊等非平台願意導致活動出現異常，平台有權利調整、暫停等措施。",
    lang22:
      "3.本遊戲為休閒娛樂，嚴禁玩家或主播之間進行線下交易，謹防上當受騙，或謀取不正當利益。",
    lang23: "4.因玩家個人的網絡或設備原因導致的遊戲損失，平台不承擔責任。",
    lang24: "5.遊戲最終解釋權歸平台所有。",
    lang25: "PK游戲記錄",
    lang26: "PK時間",
    lang27: "投擲骰子",
    lang28: "PK隊伍",
    lang29: "行駛距離",
    lang30: "勝負結果",
    lang31: "加載中...",
    lang32: "沒有更多記錄了",
    lang33: "暫無游戲PK記錄",
    lang34: "對方主播無座駕",
    lang35: "藍方隊伍無座駕",
    lang36: "紅方隊伍無座駕",
    lang37: "限速到",
    lang38: "速度",
    lang39: "需主播獲取座駕加入游戲",
    lang40: "出發",
    lang41: "提示",
    lang42: "當前未擁有座駕，無法進行游戲PK",
    lang43: "前往獲取",
    lang44: "露水獎池",
    lang45: "我方",
    lang46: "對方",
    lang47: "投擲",
    lang48: "我投擲的：",
    lang49: "獎池信息",
    lang50: "1.露水獎池：",
    lang51:
      "雙方玩家投擲骰子的露水將累計到露水獎池中，遊戲結束後獲勝隊伍將獲得露水獎池中所有的露水作為獎勵。遊戲平局時，雙方",
    lang52: "2.獎勵分配：",
    lang53:
      "根據獲勝隊伍中每名玩家擲骰子的露水佔比分配。沒有擲骰子參與遊戲的玩家不參與露水獎池的獎勵分配。",
    lang54: "3.服務費用：",
    lang55: "玩家從露水獎池中獲得獎勵，平台將收取4%的服務費用。",
    lang56: "確定",
    lang57: "提速",
    lang58: "護盾",
    lang59: "蓄能",
    lang60: "紅方",
    lang61: "藍方",
    lang62: "車輛詳細信息",
    lang63: "激活中",
    lang64: "未激活",
    lang65: "秒",
    lang66: "速度X2，持续",
    lang67: "保護中",
    lang68: "未保護",
    lang69: "护盾可免疫一次负面效果",
    lang70: "（干扰、限速）",
    lang71: "持续",
    lang72: "激活中",
    lang73: "未激活",
    lang74: "蓄能值满了后激活，赛车速度X3，持续",
    lang75: "提速持續時間",
    lang76: "加速",
    lang77: "加速模式：",
    lang78: "護盾持續時間",
    lang79: "干擾",
    lang80: "干擾模式：",
    lang81: "限速",
    lang82: "賽車獲得",
    lang83: "蓄能值，蓄能值到达100%后激活蓄能模式,蓄能模式下速度x3，持续",
    lang84: "时间结束后退出",
    lang85: "蓄能模式",
    lang86: "进度条清零。",
    lang87: "賽車獲得提速加成，速度",
    lang88: "持續",
    lang89: "时间结束后速度恢复。",
    lang90: "賽車獲得",
    lang91: "加成",
    lang92: "速度",
    lang93: "持續",
    lang94: "可免疫一次",
    lang95: "負面效果",
    lang96:
      "多次获得护盾加成时，护盾层数进行叠加，时间结束或免疫1次后护盾层数减1",
    lang97: "使用干扰效果，向对方投放一个",
    lang98: "干扰物",
    lang99: "生效后使其赛车的普通速度",
    lang100: "使用限速效果，向对方出示减速标识，使其赛车速度降低",
    lang101: "干擾",
    lang102: "限速",
    lang103: "投擲骰子",
    lang104: "投擲骰子獲得加成效果",
    lang105: "極速狂飆，并肩衝刺！",
    lang106: "口號已複製到剪貼板，請到輸入框粘貼發送！",
    lang107: "複製失敗",
    lang108: "參與賽車游戲",
    lang109: "參與條件",
    lang110: "主播持有座駕",
    lang111: "已達成",
    lang112: "未達成",
    lang113: "加入PK隊伍",
    lang115: "點擊贈送座駕",
    lang116: "點擊發送隊伍口號",
    lang117: "當前游戲未開啓，無法進行投擲。",
    lang118: "主播不允許投擲骰子",
    lang119: "極速狂飈，勝者為王！",
    lang120: "游戲未開始",
    lang121: "【極速狂飆】處於未開啓狀態無法進行游玩",
    lang122: "賽車獲得護盾加成",
    lang123: "無座駕",

    lang124: "領先",
    lang125: "落後",
  },

  /* 上播助手 */
  videoAssistant: {
    lang1: "上播助手",
    lang2: "绑定玩家为上播助手，玩家奖获得您的收礼的萤火分成",
    lang3: "上播助手",
    lang4: "輸入 ID 確認綁定玩家",
    lang5: "輸入您要綁定的玩家 ID",
    lang6: "下一步",
    lang7: "螢火分成",
    lang8: "綁定説明",
    lang9:
      "綁定上播助手之後，上播助手將獲得您收禮螢火的分成。您通過收禮收穫的螢火，將按照您設定的螢火分成比例發送給上播助手。",
    lang10: "確認",
    lang11: "綁定上播助手",
    lang12: "是否確認綁定",
    lang13: "為您的上播助手",
    lang14: "取消",
    lang15: "綁定成功",
    lang16: "綁定失敗",
    lang17: "解綁成功",
    lang18: "解綁失敗",
    lang19: "綁定玩家為上播助手，玩家將獲得您的收禮的螢火分成",
    lang20: "我的上播助手",
    lang21: "解除綁定",
    lang22: "待確認",
    lang23: "解綁上播助手",
    lang24: "解除上播助手需要對方確認后可以完成解除綁定，是否解除綁定",
    lang25: "為您的上播助手？",
    lang26: "拒絕解綁成功",
    lang27: "拒絕解綁失敗",
    lang28: "上播助手设置",
    lang29: "收穫螢火",
    lang30: "對方解除綁定您的上播助手身份，需要您進行確認後才可以解除",
    lang31: "解綁申請",
    lang32: "對方已申請解綁您的上播助手身份，請您確認",
    lang33: "拒絕",
    lang34: "綁定我為上播助手的主播列表",
    lang35: "暂无绑定主播",
    lang36: "解綁上播助手",
    lang37: "是否解除綁定您與",
    lang38: "的上播助手關係？",

    lang39: "用戶已封禁",
    lang40: "您輸入的ID搜尋失敗",
  },

  /* 夜间选秀 */
  nightDraft: {
    lang1: "活動規則",
    lang2: "實況",
    lang3: "往期",
    lang4: "您已放棄今日參賽",
    lang5: "放棄今日參數失敗",
    lang6: "放棄參賽",
    lang7: "我的排名",
    lang8: "勝場",
    lang9: "參賽説明",
    lang10:
      "請晉級半決賽/決賽的主播在半決賽/決賽開始的時間保持開播狀態且未在PK中,系統將自動發起半決賽/決賽雙方主播的PK。",
    lang11: "半決賽",
    lang12: "5局3勝制,獲勝主播晉級決賽",
    lang13: "海選No.1 VS 海選No.4",
    lang14: "海選No.2 VS 海選No.3",
    lang15: "決賽",
    lang16: "5局3勝制,獲勝主播成為當日「熒光夜間選秀」冠軍",
    lang17: "半決賽勝者",
    lang18:
      "注：如果您滿足半決賽/決賽參與條件但無法參與，請在每天20:30之前點擊",
    lang19: "放棄參賽 >",
    lang20: "缺席比賽將在未來14天無法參加「熒光夜間選秀」活動",
    lang21: "放棄參賽",
    lang22: "放棄參賽將退出海選階段排名,次日將恢復您的參賽資格。",
    lang23: "是否放棄參加今日",
    lang24: "的「熒光夜間選秀」活動",
    lang25: "取消",
    lang26: "確認",
    lang27: "勝場",
    lang28: "未完賽",
    lang29: "暫無往期記錄",
    lang30: "參與「熒光夜間選秀」",
    lang31:
      "主播使用FIREFLY V54.0以上版本開啟PK（包含「人氣PK」和「遊戲PK」），即可參加「熒光夜間選秀」活動。",
    lang32: "海選",
    lang33: "時間：每日20:30-次日20:30",
    lang34:
      "規則：與主播(獲得過「新星認定」)發起PK即可參與當日的海選榜單。海選榜單累計主播當日所有完赛的PK人氣值總和進行排名",
    lang35: "晉級：截止每日20:30，海選前4名主播晉級半決賽",
    lang36:
      "放棄參賽：如果主播無法在半決賽/決賽的指定時間開播，可以在海選時間段內選擇放棄參賽。主播放棄參賽後排名下一位的主播將頂上。",
    lang37: "半決賽",
    lang38: "時間：每日21:00/21:20",
    lang39:
      "規則：系統將在指定時間自動發起半決賽雙方主播的PK，PK規則為「人氣PK」5局3勝制。請主播在此時間內保持開播狀態。",
    lang40: "晉級：贏家將晉級決賽",
    lang41:
      "放棄參賽：主播在半決賽開始時未在開播狀態，視為放棄參賽。無法獲得名次獎勵，並在未來15天無法再次參與「熒光夜間選秀」",
    lang42: "半决赛对阵：每日海選結束後由系統隨機抽籤產生",
    lang44: "半決賽失敗方根據當日最高人氣值排名，決出No.3/No.4",
    lang45: "決賽",
    lang46: "時間：每日22:00",
    lang47:
      "規則：系統將在指定時間自動發起決賽雙方主播的PK，PK規則為「人氣PK」5局3勝制。請主播在此時間內保持開播狀態。",
    lang48: "晉級：贏家獲得當日「熒光夜間選秀」冠軍",
    lang49:
      "放棄參賽：主播在決賽開始時未在開播狀態，視為放棄參賽。無法獲得名次獎勵，並在未來15天無法再次參與「熒光夜間選秀」",
    lang50: "決賽勝利方為當日冠軍，失敗方為當日No.2",
    lang51: "獎勵",
    lang52: "玩家露水獎勵：",
    lang53: "半決賽1：獲勝方的隊伍將平分",
    lang54: "半決賽2：獲勝方的隊伍將平分",
    lang55: "決賽：獲勝方的隊伍將平分",
    lang56: "主播積分獎勵：",
    lang57:
      "參與半決賽/決賽的主播，決出勝負之後，前4名可以獲得「直播獎勵」的積分。放棄參賽的主播將無法獲得積分獎勵。具體積分請查看",
    lang58: "「直播獎勵」>",
    lang59: "注意事項",
    lang60: "1.活動僅限女性主播參與",
    lang61:
      "2.被限制活動參與資格期間，所有活動數據均為無效數據，需在接觸限制後重新獲取",
    lang62:
      "3.主播需積極與玩家互動，有違反《主播直播公約》以及破壞活動平衡的行為，平台有權取消其活動資格以及活動積分（包括但不限於掛臉直播、無質量、黑屏、掛機、直播打遊戲、看電視、串通PK結果、消極比賽等）。違反以上規則的主播，平臺將處以「紅牌懲罰」。",
    lang63: "4. 活動最終解釋權歸平台所有",
    lang64: "海選中",
    lang65: "20:30-次日20:30",
    lang66:
      "與主播開啟PK即可參與海選排名，海選榜單累計當日有效PK場次的人氣值，排名前4名晉級半決賽",
    lang67: "晋级区",
    lang68: "暫無海選記錄",
    lang69: "「FIREFLY」您預約了熒光夜間選秀決賽",
    lang70: "每天21:00-23:00，PK贏露水獎勵",
    lang71: "決賽主播未決出",
    lang72: "半决赛主播未决出",
    lang73: "半決賽勝者",
    lang74: "海选NO.1",
    lang75: "海选NO.2",
    lang76: "海选NO.3",
    lang77: "海选NO.4",
    lang78: "订阅提醒 >",
    lang79: "獲勝隊伍獎勵",
    lang80: "五局三胜",
    lang81: "已鎖榜",
    lang82: "暫無排名",
    lang83: "「FIREFLY」您預約了熒光夜間選秀半決賽1",
    lang84: "「FIREFLY」您預約了熒光夜間選秀半決賽2",
    lang85: "加載更多中...",
    lang86: "向下滑動加載更多",
    lang87: "暫無更多了",
    lang88: "紅牌處罰：",
    lang89: "a.取消當日「熒光夜間選秀」的獎勵領取資格",
    lang90: "b.未來5天禁止參與「熒光夜間選秀」活動",
    lang91: "獎勵",
    lang92: "每天「熒光夜間選秀」中獲得前四名的主播，可獲得獎勵",
    lang93: "冠軍",
    lang94: "NO.2",
    lang95: "NO.3/NO.4",
    lang96: "其他名次",
    lang97: "無獎勵",
    lang98: "領取",
    lang99: "未獲得熒光夜間選秀獎勵",
    lang100: "已領取",
    lang101: "您已領取熒光夜間選秀獎勵",
    lang102: "領取成功",
    lang103: "主播可獲得寶石獎勵：",
    lang104: "冠軍：",
    lang105: "第二名：",
    lang106: "第三名/第四名：",

    lang107: "决赛奖励",
    lang108: "结果",
    lang109: "奖励",
    lang110: "胜",
    lang111: "负",
    lang112: "未完赛",
    lang123: "无奖励",
    lang124: "半决赛奖励",
    lang125: "海选奖励",
    lang126: "決賽獎勵",
    lang127: "參與「熒光夜間選秀」決賽，決賽結束後可領取",
    lang128: "半決賽獎勵",
    lang129: "參與「熒光夜間選秀」半決賽，決賽結束後可領取",
    lang130: "海選獎勵",
    lang131: "參與「夜間選秀決賽」獲得前八名可領取，每天21:00 發放",
    lang132: "未開始",
    lang133: "PK中",
    lang134: "已結束",
    lang135: "暂无可领取奖励",
    lang136: "您已领取过奖励",
    lang137: "參與熒光夜間選秀PK,每日贏",
    lang138: "領取",
    lang139: "已領取",
    lang140: "領取獎勵",
    lang141: "我的獎勵",
    lang142: "中",
    lang143: "NO.1-NO.4",
    lang144: "海選排名",
    lang145: "NO.5-NO.8",
    lang146: "無獎勵",
    lang147: "其他排名",
    lang148: "未参赛",
    lang149: "獎勵區",
    lang150: "請更新APP到V57.0版本以上領取獎勵！",

    lang151: "賽段結果",
    lang153: "海選Top4",
    lang152: "今日夜間選秀決出最終名次后可領取",
  },

  /* firstLove */
  firstLove: {
    lang1: "FirstLove",
    lang2:
      "新玩家注册7天内，完成「首充大礼包」储值活动获得「FirstLove」礼物奖励。「FirstLove」礼物送出后将绑定主播为FirstLove， 在直播间发言将有专属标签。每个玩家仅能绑定一个 FirstLove。",
    lang3: "「首充大礼包」入口",
    lang4: "背包送礼",
    lang5: "FirstLove 首禮榜",
    lang6:
      "FirstLove首禮榜按照主播收到的FirstLove首禮數量進行排行，收到數量更多排名更靠前。如果多名主播收到FirstLove數量一致，",
    lang7: "先達到此數量的主播排名更靠前。",
  },

  /* 迎新奖励 */
  newsRewards: {
    lang1: "每日獎勵",
    lang2: "獎勵記錄",
    lang3: "迎新任務",
    lang4: "積分",
    lang5: "完成「迎新 PK」，每天最多可領6000積分",
    lang6: "迎新PK",
    lang7: "每完成1場「迎新PK」(60分鐘)，根據 PK 結果領取積分獎勵",
    lang8: "場",
    lang9: "已獲得",
    lang10: "領取",
    lang11: "已領取",
    lang12: "積分兌換",
    lang13: "我的積分",
    lang14: "獎勵",
    lang15: "階",
    lang16: "纍計積分達到",
    lang19: "積分獎勵",
    lang20: "迎新獎勵",
    lang21: "每日開啟迎新PK，專屬流量扶持",
    lang22: "積分",
    lang25: "讚",
    lang26: "暫無數據",
    lang27: "迎新獎勵規則",
    lang28: "迎新PK",
    lang29:
      "迎新主播在發起 PK 時，選擇「迎新PK」並開始匹配。迎新 PK 比拼雙方主播的按讚數。",
    lang30: "獲得讚的方式：",
    lang31: "收穫新玩家專屬禮物",
    lang32: "專屬禮物說明：",
    lang33: "禮物名稱：",
    lang34: "獲取方式：",
    lang35:
      "新註冊玩家將免費獲得該禮物，有效期48小時。可以在直播間內點擊「新人好禮」領取。",
    lang36: "按讚",
    lang37: "FirstLove",
    lang38:
      "新玩家註冊7天內，完成「首充大禮包」儲值活動獲得「FirstLove」禮物獎勵。",
    lang39: "您已領取過當日的積分",
    lang40: "未達到獎勵要求，無法領取積分",
    lang41: "成功領取迎新獎勵積分",
    lang42: "迎新流量扶持",
    lang43:
      "開啟「迎新 PK」，將會獲得迎新流量扶持。迎新PK 期間新註冊的玩家將主動推送到「迎新 PK」的直播間。",
    lang44: "積分領取",
    lang45: "完成「每日獎勵」贏取積分，纍計積分達到相應等級即可領取螢火獎勵",
    lang46: "注意事項",
    lang47: "1.活動僅限女性主播參與",
    lang48: "3.每台設備僅限一個賬號領取，多賬號領取將被取消活動資格不再恢復",
    lang49:
      "4.被限制活動參與資格期間，所有活動數據均為無效數據，需在解除限制後重新獲取",
    lang50:
      "5.「每日獎勵」積分需自行領取，請在2025年12月03日 12:00前進行領取，過期不再補發",
    lang51:
      "6.已有邀請人綁定的賬號不允許開小號直播領取積分，發現後取消所有賬號參與資格不再恢復",
    lang52:
      "7.無邀請人綁定的賬號不受大小號限制，視情況給予參與資格，但只能選擇一個賬號參與獎勵活動",
    lang53:
      "8.主播需積極與玩家互動，有違反《主播直播公約》以及破壞活動平衡的行為，平台有權取消其活動資格以及活動積分（包括但不限於掛臉直播、無質量、黑屏、掛機、直播打遊戲、看電視等）",
    lang54: "9.活動最終解釋權歸平台所有",
    lang55: "2.活動時長每兩分鐘統計一次",
    lang56: "迎新獎勵",
    lang57: "勝",
    lang58: "平",
    lang59: "負",
    lang60: "獎勵一階",
    lang61: "獎勵二階",
    lang62: "獎勵三階",
    lang63: "獎勵四階",
    lang64: "獎勵等級",
    lang65: "積分要求",
    lang66: "積分達到",
    lang67: "可領取",
    lang68: "積分兌換成功",
    lang69: "按讚",
    lang70: "讚",
    lang71: "您已領取過當天的積分",
  },

  /* 合作联系 */
  cooperate: {
    lang1: "你的留言已提交成功！",
    lang2: "你的暱稱",
    lang3: "聯繫媒介：",
    lang4: "聯繫方式：",
    lang5:
      "非常感謝您的合作留言，以及給FIREFLY的成長意見，會有工作人員與您取得聯繫。請留意您留下的聯繫方式。",
    lang6: "主播合作介紹",
    lang7: "查看使者主頁",
    lang8: "返回首頁",
    lang9:
      "FIREFLY的主播或者用戶邀請者、公會人員，成為使者，可以和自己邀請對象成為信中關係，獲得長期獎勵。優秀的使者還將能自動獲得社區內的特權",
    lang10: "請留下您的聯繫方式",
    lang11: "請留下您的另一種聯繫方式（選填）",
    lang12: "您想給到FIREFLY的留言",
    lang13: "請填寫您想給到FIREFLY的留言",
    lang14: "確認提交",
    lang15: "選擇聯繫媒介",
    lang16: "微信 Wechat",
    lang17: "主播合作",
    lang18: "獨立主播自助加入FIREFLY",
    lang19: "使者合作",
    lang20: "以公會方式加入FIREFLY",
    lang21: "商務合作",
    lang22: "推廣與媒介",
    lang23: "玩家意見",
    lang24: "FIREFLY玩家意見提交管道",
    lang25: "合作聯繫",
    lang26: "請填寫您的FIREFLY ID",
    lang27: "請填寫您的Whatsapp ID",
    lang28: "請填寫您的Telegram ID",
    lang29: "請填寫您的Facebook ID",
    lang30: "請填寫您的Email",
    lang31: "請填寫您的Wechat",
    lang32: "請填寫您的Line",
    lang33: "請稍後重試",
    lang34: "請輸入您的暱稱",
    lang35: "請輸入您的聯繫方式",
    lang36: "請輸入您的留言",
  },
  premiumNumberCommitLetter: {
    lang1: "靚號啟用承諾書",
    lang2: "親愛的",
    lang3: "原ID：",
    lang4: "您申請的靚號",
    lang5: "即將為您啟用。為維護平台秩序與賬號安全，請仔細閱讀並同意以下約定：",
    lang6:
      "因您現在獲得的靚號，是FIREFLY社區稀缺且不可再生資源，這種類型的帳號轉讓會對社區的穩定和結構造成負面影響。",
    lang7: "【承諾約定】",
    lang8:
      "1.本人承諾，該靚號僅限本人使用，不會以任何形式（包括但不限於出售、出租、贈與、轉讓）提供給第三方。",
    lang9:
      "2.本人知曉，若違反上述承諾，平台有權收回該靚號，並可能對原賬號進行限制處理（如封禁、降權等）。",
    lang10:
      "3.本人承諾遵守平台相關用戶協議及法律法規，不利用靚號進行違規或違法行為。",
    lang11: "本承諾一經簽署即具有約束力。感謝您的理解與配合。",
    lang12: "我不同意",
    lang13: "我同意",
    lang14: "用户已同意",
    lang15: "同意時間：",
    lang16: "已提交遷移申請",
    lang17: "具體遷移時間會有專屬客服與您溝通，感謝您的理解與支持～",
    lang18: "我知道了",
    lang19: "您已成功申請，感謝您的理解與支持～",
    lang20: "刷新",
    lang21: "客服諮詢",
    lang22: "關閉頁面",
    lang23: "更多",
  },
  vipUpPublicNotice: {
    lang1: "為了給您帶來更加尊貴、專屬的互動體驗，我們將於",
    lang2: "2026年8月4日",
    lang3: "正式上線全新的富豪等級體系",
    lang4:
      "本次調整將劃分部分VIP等級所需富豪值，以及新增配置更豐富、更震撼的特權權益。以下是主要變化説明：",
    lang5: "新體系更新上綫後，原有富豪等級將",
    lang6: "自動根據富豪值繼承",
    lang7: "至新體系中對應VIP等級",
    lang8:
      "如您之前的富豪等級是VIP43，富豪值為3254120，現等級平移繼承為VIP45，富豪值不變，並獲得對應的VIP等級特權！",
    lang9: "權益類型",
    lang10: "具體特權",
    lang11: "解鎖等級",
    lang12: "身份隱藏",
    lang13: "隱身",
    lang14: "管理豁免",
    lang15: "防踢防禁言",
    lang16: "個性座駕",
    lang17: "定制專屬座駕",
    lang18: "靚號體系",
    lang19: "6位 / 5位 / 4位靚號",
    lang20: "彈幕炫彩",
    lang21: "3色 / 5色自定義",
    lang22: "專屬服務",
    lang23: "專屬客服通道",
    lang24: "充值特惠",
    lang25: "專屬充值通道",
    lang26: "名片美化",
    lang27: "靜態/動態個人名片背景",
    lang28: "定制禮物",
    lang29: "中級禮物（5秒） / 高級禮物（10秒）",
    lang30: "全站通知",
    lang31: "上線全站通知",
    lang32: "在平臺發展過程中，我們將",
    lang33: "不斷完善VIP等級特權以及服務體驗",
    lang34: "，如有特權規則或權益等變更，我們將及時發佈調整公告，敬請留意",
    lang35: "Firefly保留最終解釋權",
  },
  // Ludo
  ludo: {
    clubPkRoom: "{club}的 PK 房間",
    lang1: "開啟房間",
    lang2: "快速加入",
    lang3: "入場",
    lang4: "等待中",
    lang5: "當前暫無Ludo PK 房間",
    lang6: "玩法模式",
    lang7: "默認俱樂部",
    lang8: "經典",
    lang9: "無限制",
    lang10: "戰績",
    lang11: "排行",
    lang12: "入場露水",
    lang13: "玩法信息",
    lang16: "支付入場露水加入Ludo PK",
    lang17: "玩家人數",
    lang18: "獲勝獎勵",
    lang19: "聲望",
    lang20: "我的道具",
    lang21: "棋子",
    lang22: "棋盤",
    lang23: "選擇您在LUDO遊戲中使用的棋子道具。",
    lang24: "選擇您的社團PK房間在LUDO遊戲中使用的棋盤道具。",
    lang25: "時間徽章",
    lang26: "已選擇",
    lang27: "默認",
    lang28: "請選擇道具",
    lang31: "使用",
    lang32: "點擊選擇要使用的道具",
    lang33: "點擊使用，下一場LUDO遊戲將使用該棋盤道具",
    lang34: "點擊使用，下一場LUDO遊戲將使用該棋子道具",
    lang35: "已在使用中",
    lang36: "請選擇要使用的道具",
    lang37: "使用成功，下一場LUDO遊戲生效",
    lang38: "天",
    lang39: "小時",
    lang40: "分鐘",
    lang42: "當前暫無LUDO PK記錄",
    lang43: "遊戲詳情",
    lang45: "房費",
    lang46: "時間",
    lang47: "露水",
    lang49: "日期",
    lang50: "總計",
    lang51: "玩家頭像",
    lang52: "排名",
    lang53: "第1名",
    lang54: "第2名",
    lang55: "第3名",
    lang56: "第4名",
    lang57: "加載中...",
    lang58: "客服",
    lang59: "勝",
    lang60: "負",
    lang61: "平",
    lang62: "玩法說明",
    lang63: "遊戲規則",
    lang64: "玩法人數",
    lang66: "勝負判定",
    lang68: "社團聲望",
    lang69: "參與遊戲",
    lang70: "中途加入",
    lang72: "起飛",
    lang73: "三連六",
    lang74: "行動",
    lang75: "疊子",
    lang76: "吃子",
    lang77: "安全區",
    lang78: "2-4人",
    lang79:
      "經典：玩家的棋子都需要從起點開始繞圖一圈後到達終點，所有棋子都抵達終點則判定為完成遊戲。越快完成遊戲名次越高。",
    lang80:
      "根據玩法模式，先完成遊戲的玩家名次越高。例如第一個完成遊戲的玩家為本局遊戲的第一名，以此類推。",
    // lang81: "遊戲結束之後，根據您的名次可以獲得露水、聲望獎勵。",
    lang81: "遊戲結束之後，根據您的名次可以獲得露水。",
    lang82:
      "如果您在已加入的社團房間內贏得遊戲，則根據遊戲排名增加您在該社團中的聲望。",
    lang83: "支付房主設定的入場露水，可以加入遊戲。",
    lang84: "已經開始的遊戲中，玩家可以在中途支付入場露水加入Ludo PK。",
    lang85: "需要骰子投到點數六，棋子才可以從基地起飛到起始格子。",
    lang86: "同一回合內累計投出3個點數六時，則觸發三連六，玩家跳過此回合。",
    lang87: "玩家投擲骰子獲得點數，用以移動棋子前進對應的步數。",
    lang88:
      "相同玩家的棋子停留在同一處則成為疊子，被吃子時疊子會被全部踢回基地。",
    lang89:
      "棋子行動結束後落在的格子上如果有其他玩家的棋子，則將所有其他玩家的棋子踢回基地，需要重新起飛才可以進行行動。",
    lang90:
      "棋子落在棋盤上的起點和帶盾牌的格子，不會被吃子。不同玩家的棋子可以同時停留在這些格子上。",
    lang91:
      "每局遊戲收取固定露水數量作為房費，房費金額根據入場露水數量確定，與遊戲人數無關。遊戲結算發放獎勵露水時，系統將自動扣除房費後，發放贏家獎勵露水",
    lang92: "加入遊戲",
    lang93: "遊戲房費",
    lang94: "勝場",
    lang95: "玩家",
    lang96: "結算露水",
    lang97: "場費",
    lang98: "底注",
    lang99: "/場",
    lang100: "我的成績",
    lang101: "參與玩家",
    lang102: "記錄",
  },
  teenPatti: {
    recordTitle: "記錄",
    rankingTitle: "排行榜",
    confirm: "確認",
    // 玩法设定页：配置与加入暂用 mock，接口接入后移除模拟提示。
    settingsTitle: "玩法設定",
    maxBet: "最大下露",
    maxPot: "最大底池",
    buyInDew: "帶入露水",
    mockJoinTip: "模擬模式：已選擇底露 {ante}，暫未接入加入介面",
    // 社团名称由 i18n-t 插槽提供，保持各语言的正确语序。
    clubPkRoom: "{club}的 PK 房間",
    // 三张牌规则页文案，统一由全局国际化管理。
    title: "玩法說明",
    hands: "牌型",
    play: "玩法",
    order: "牌力從高到低排列",
    players: "玩法人數：2–5人",
    mode: "玩法模式：",
    intro: "「三張牌」是一款基於三張撲克牌進行大小比對的策略博弈遊戲。玩家需根據手中的牌型以及對手的下露行為進行判斷，透過跟注、加注或比牌等行動，爭奪最終的底池露水獎勵。牌力不比較牌面花色大小。",
    flow: "遊戲流程",
    ante: "底露",
    anteText: "遊戲開始時，每位玩家將自動扣除固定的「底露」投入當局底池。底露數量由房主設定。",
    deal: "發牌階段",
    dealText: "系統向每位參與玩家發放 3 張暗牌，只有玩家本人選擇「看牌」後才可見自己的手牌。",
    turn: "回合操作",
    turnText: "系統按順序輪流交由玩家進行操作，直到場上僅剩 1 名玩家，或達到底池上限或回合數上限為止。",
    actions: "玩家行動",
    blind: "暗牌狀態",
    blindText: "玩家在未查看自己底牌的情況下進行下露。此狀態下的跟注或加注為下露數量的 1 倍。",
    seen: "看牌狀態",
    seenText: "玩家查看底牌後繼續參與遊戲。此狀態下，玩家的跟注或加注將為暗牌玩家的 2 倍。",
    compare: "比牌",
    condition: "條件",
    conditionText: "每場遊戲進入第 2 輪後，玩家可以選擇是否發起比牌。",
    cost: "規則",
    costText: "發起比牌需支付當前單次下露額的 2 倍露水。",
    compareResult: "勝負判定",
    compareResultText: "發起者可指定場上任意一名活躍玩家進行暗中比牌，若雙方牌型與點數完全一致，基於避險規則，主動發起比牌的一方將判定為輸。輸家將被淘汰出當局牌桌。",
    fold: "棄牌",
    foldText: "玩家主動放棄本局遊戲，先前已投入底池的露水不予退還。",
    allIn: "All in",
    allInText: "當玩家餘額不足以支付當前的最低跟注額時，可進行 All in，系統將剩餘全部餘額投入底池，隨後本局內不可再進行任何操作。系統將為其保留手牌，直至最終回合進行強制攤牌比對。",
    settlement: "遊戲結算",
    end: "回合上限",
    endText: "為保障遊戲流暢度，每局遊戲設有最大回合數限制（具體以房間顯示為準）。",
    showdown: "強制開牌",
    showdownText: "當達到最大回合數，或場上僅剩 2 名玩家且其中一方發起明牌時，系統將強制公開剩餘玩家的底牌進行最終比對。",
    reward: "露水獎勵",
    rewardText: "最終勝出的玩家將贏得本池內的全部露水（系統將依平台規範扣除固定比例的服務費／抽成後發放）。",
    hand1: "豹子",
    desc1: "三張點數相同的牌，如 AAA、222 等",
    hand2: "順金",
    desc2: "花色相同的順子，如黑桃 456 等",
    hand3: "金花",
    desc3: "花色相同但非順子的三張牌",
    hand4: "順子",
    desc4: "花色不同的順子，如紅桃 5、方塊 6、黑桃 7",
    hand5: "對子",
    desc5: "兩張點數相同的牌加一張單張，如 223",
    hand6: "高牌",
    desc6: "不符合以上任何組合的普通牌",
    hand7: "235",
    desc7: "不同花色的 2、3、5 組成，僅在牌桌上有豹子存在時，235 吃豹子，其他情況下 235 只作為高牌計算。",
    rankOrder: "同類牌型按點數比較：A 最大，2 最小；豹子 AAA 最大、222 最小。順金和順子 A–K–Q 最大、3–2–A 最小。",
    sameHand: "金花與高牌先比較最大牌點數；相同則依次比較第二大、第三大牌。花色不比較大小。",
    samePair: "對子先比較對子點數；相同則比較單張點數。",
    lang1: "開啟房間",
    lang2: "快速加入",
    lang3: "入場",
    lang4: "等待中",
    lang5: "當前暫無三張牌 PK 房間",
    lang6: "玩法模式",
    lang7: "默認俱樂部",
    lang8: "經典",
    lang9: "無限制",
    lang10: "戰績",
    lang11: "排行",
    lang12: "入場露水",
    lang13: "玩法信息",
    lang16: "支付入場露水加入Ludo PK",
    lang17: "玩家人數",
    lang18: "獲勝獎勵",
    lang19: "聲望",
    lang20: "我的道具",
    lang21: "棋子",
    lang22: "棋盤",
    lang23: "選擇您在LUDO遊戲中使用的棋子道具。",
    lang24: "選擇您的社團PK房間在LUDO遊戲中使用的棋盤道具。",
    lang25: "時間徽章",
    lang26: "已選擇",
    lang27: "默認",
    lang28: "請選擇道具",
    lang31: "使用",
    lang32: "點擊選擇要使用的道具",
    lang33: "點擊使用，下一場LUDO遊戲將使用該棋盤道具",
    lang34: "點擊使用，下一場LUDO遊戲將使用該棋子道具",
    lang35: "已在使用中",
    lang36: "請選擇要使用的道具",
    lang37: "使用成功，下一場LUDO遊戲生效",
    lang38: "天",
    lang39: "小時",
    lang40: "分鐘",
    lang42: "當前暫無Teenpatti PK記錄",
    lang43: "遊戲詳情",
    lang45: "房費",
    lang46: "時間",
    lang47: "露水",
    lang49: "日期",
    lang50: "總計",
    lang51: "玩家頭像",
    lang52: "排名",
    lang53: "第1名",
    lang54: "第2名",
    lang55: "第3名",
    lang56: "第4名",
    lang57: "加載中...",
    lang58: "客服",
    lang59: "勝",
    lang60: "負",
    lang61: "平",
    lang62: "玩法說明",
    lang63: "遊戲規則",
    lang64: "玩法人數",
    lang66: "勝負判定",
    lang68: "社團聲望",
    lang69: "參與遊戲",
    lang70: "中途加入",
    lang72: "起飛",
    lang73: "三連六",
    lang74: "行動",
    lang75: "疊子",
    lang76: "吃子",
    lang77: "安全區",
    lang78: "2-4人",
    lang79:
      "經典：玩家的棋子都需要從起點開始繞圖一圈後到達終點，所有棋子都抵達終點則判定為完成遊戲。越快完成遊戲名次越高。",
    lang80:
      "根據玩法模式，先完成遊戲的玩家名次越高。例如第一個完成遊戲的玩家為本局遊戲的第一名，以此類推。",
    // lang81: "遊戲結束之後，根據您的名次可以獲得露水、聲望獎勵。",
    lang81: "遊戲結束之後，根據您的名次可以獲得露水。",
    lang82:
      "如果您在已加入的社團房間內贏得遊戲，則根據遊戲排名增加您在該社團中的聲望。",
    lang83: "支付房主設定的入場露水，可以加入遊戲。",
    lang84: "已經開始的遊戲中，玩家可以在中途支付入場露水加入Ludo PK。",
    lang85: "需要骰子投到點數六，棋子才可以從基地起飛到起始格子。",
    lang86: "同一回合內累計投出3個點數六時，則觸發三連六，玩家跳過此回合。",
    lang87: "玩家投擲骰子獲得點數，用以移動棋子前進對應的步數。",
    lang88:
      "相同玩家的棋子停留在同一處則成為疊子，被吃子時疊子會被全部踢回基地。",
    lang89:
      "棋子行動結束後落在的格子上如果有其他玩家的棋子，則將所有其他玩家的棋子踢回基地，需要重新起飛才可以進行行動。",
    lang90:
      "棋子落在棋盤上的起點和帶盾牌的格子，不會被吃子。不同玩家的棋子可以同時停留在這些格子上。",
    lang91:
      "每局遊戲收取固定露水數量作為房費，房費金額根據入場露水數量確定，與遊戲人數無關。遊戲結算發放獎勵露水時，系統將自動扣除房費後，發放贏家獎勵露水",
    lang92: "加入遊戲",
    lang93: "遊戲房費",
    lang94: "勝場",
    lang95: "玩家",
    lang96: "結算露水",
    lang97: "場費",
    lang98: "底露",
  },
};
